import { CircularProgress } from '@mui/material';

export function LoadingIcon({
  isLoading = false,
  size = 16,
  color = 'primary',
}) {
  return isLoading ? <CircularProgress size={size} color={color} /> : null;
}
